import request from '@/utils/requset'

// 文章菜单列表
export function menuList(data) {
  return request({
    url: `h5/article/menuList`,
    method: 'post',
    data: data
  })
}

// 文章列表
export function articles(data) {
  return request({
    url: `h5/article/lists`,
    method: 'post',
    data: data
  })
}

// 文章详情
export function articleInfo(id) {
  return request({
    url: `h5/article/${id}`,
    method: 'post',
  })
}